// src/realms/cosmos/appearance.ts
var DEFAULT_CONSTELLATION_APPEARANCE = {
  titleFontSize: 34,
  titleOpacity: 0.82,
  titleColor: "#c8dce8",
  titleLetterSpacing: 6,
  titleYOffset: -2.5,
  titleBelowPreviewGap: 6,
  titleBelowPreviewFontSize: 22,
  titleDistanceFactor: 12,
  htmlZIndexRange: [8, 0],
  previewWidth: 192,
  previewHeight: 124,
  previewOffsetY: 2.4,
  labelFontSize: 13,
  labelLetterSpacing: 1.2,
  labelMaxWidth: 240,
  labelGap: 10,
  controlsGridHeight: 92,
  billboardDistanceFactor: 10,
  showSceneLabels: false,
  publishedEffect: {
    enabled: true,
    starSaturationBoost: 18,
    starLightnessBoost: 14,
    edgeGlowMultiplier: 1.65,
    dust: {
      enabled: true,
      count: 28,
      orbitRadius: 1.35,
      speed: 0.42,
      color: "#c8dce8",
      opacity: 0.5
    }
  },
  focusEffect: {
    enabled: true,
    starPulseAmplitude: 0.22,
    starPulseSpeed: 2.4,
    glowScale: 1.45,
    glowOpacityBoost: 0.12,
    shockwaveEnabled: true,
    pointLightIntensity: 2.8
  },
  cameraDefaultOffset: [0, 4, 12],
  cameraTargetOffset: [0, 0, 0],
  cameraSlideLerp: 0.035,
  cameraArrivalThreshold: 0.08
};
function mergeConstellationAppearance(overrides) {
  const base = { ...DEFAULT_CONSTELLATION_APPEARANCE, ...overrides };
  if (overrides?.publishedEffect) {
    base.publishedEffect = {
      ...DEFAULT_CONSTELLATION_APPEARANCE.publishedEffect,
      ...overrides.publishedEffect,
      dust: {
        ...DEFAULT_CONSTELLATION_APPEARANCE.publishedEffect.dust,
        ...overrides.publishedEffect.dust
      }
    };
  }
  if (overrides?.focusEffect) {
    base.focusEffect = {
      ...DEFAULT_CONSTELLATION_APPEARANCE.focusEffect,
      ...overrides.focusEffect
    };
  }
  return base;
}

// src/realms/cosmos/index.ts
var GENRE_HUE_OFFSET = {
  drama: 50,
  thriller: 220,
  horror: 0,
  comedy: 35,
  romance: 340,
  scifi: 200,
  documentary: 180,
  animation: 280
};
var MOOD_HUE = {
  bright: 50,
  warm: 25,
  bittersweet: 290,
  somber: 230,
  tense: 210,
  playful: 110,
  melancholy: 250
};
function clamp01(n) {
  return Math.max(0, Math.min(1, n));
}
function popularityToIntensity(film) {
  const watches = Math.max(0, film.watch_starts_count);
  const log = Math.log10(1 + watches);
  return clamp01(log / 6);
}
function deriveScale(film) {
  const scenes = film.scenes_count ?? 1;
  return clamp01(0.25 + Math.log10(1 + scenes) / 4);
}
function deriveHue(film) {
  const genreKey = (film.genre ?? "").toLowerCase().replace(/[^a-z]/g, "");
  const moodKey = "";
  const moodHue = MOOD_HUE[moodKey];
  const genreOffset = GENRE_HUE_OFFSET[genreKey];
  if (moodHue !== void 0) return moodHue;
  if (genreOffset !== void 0) return genreOffset;
  return 210;
}
function deriveState(film) {
  return film.published ? "default" : "new";
}
var cosmosMapping = (film) => ({
  position: [0, 0, 0],
  // assigned by the realm's spatial layouter
  scale: deriveScale(film),
  hue: deriveHue(film),
  intensity: popularityToIntensity(film),
  state: deriveState(film),
  metadata: {
    title: film.title,
    popularity: film.watch_starts_count,
    genre: film.genre
  }
});
var cosmosMotion = {
  flightAcceleration: 14,
  flightDamping: 0.92,
  focusEaseMs: 380,
  engageDurationMs: 900,
  backDurationMs: 900
};
var cosmosAudio = {
  // Asset paths are resolved by the host app's asset bundler; chuzi-shared
  // only declares the contract. Replace with CDN URLs at integration time.
  ambientLoop: "audio/cosmos/ambient-deep.ogg",
  focusChime: "audio/cosmos/focus-shimmer.ogg",
  engageImpact: "audio/cosmos/dolly-in.ogg",
  backWhoosh: "audio/cosmos/dolly-out.ogg"
};

export { DEFAULT_CONSTELLATION_APPEARANCE, cosmosAudio, cosmosMapping, cosmosMotion, mergeConstellationAppearance };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map